// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NewRegistrationForm-module-container-RAcdJ{max-width:380px;margin-block:44px 12px;margin-inline:auto}@media(min-width: 960px){.NewRegistrationForm-module-container-RAcdJ{max-width:700px;margin-block:44px 40px;margin-inline:auto}}@media(min-width: 960px){.NewRegistrationForm-module-title-qmJnu{padding-inline:25% 30%}}.NewRegistrationForm-module-link-z8HO0{display:block}@media(min-width: 960px){.NewRegistrationForm-module-link-z8HO0{display:inline;margin-inline-start:6px}}.NewRegistrationForm-module-deviceCodeWrapper--x-g1{margin-bottom:50px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "NewRegistrationForm-module-container-RAcdJ",
	"title": "NewRegistrationForm-module-title-qmJnu",
	"link": "NewRegistrationForm-module-link-z8HO0",
	"deviceCodeWrapper": "NewRegistrationForm-module-deviceCodeWrapper--x-g1"
};
export default ___CSS_LOADER_EXPORT___;
